import { Pagination as ExoPagination } from "@exopengithub/exokit";
import type { ComponentProps } from "react";
import { useTranslation } from "react-i18next";

// Injects Swedish default labels and hides itself below 2 pages so callers don't each reimplement the guard.
export const Pagination = (props: ComponentProps<typeof ExoPagination>) => {
	const { t } = useTranslation();
	if (props.totalPages <= 1) {
		return null;
	}
	return (
		<ExoPagination
			firstPageLabel={t("First page")}
			previousPageLabel={t("Previous page")}
			nextPageLabel={t("Next page")}
			lastPageLabel={t("Last page")}
			{...props}
		/>
	);
};
